// extracted by mini-css-extract-plugin
export default {"loader-wrapper":"style_loader-wrapper__f-vki"};